import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Gallery from '../components/ui/Gallery';
import { AwardIcon, TrophyIcon, MedalIcon, StarIcon, CheckIcon } from 'lucide-react';
const PrizesAndAwards = () => {
  const recentAwards = [{
    title: 'Royal Camel Area Science Club Competition',
    category: 'Science',
    year: '2024',
    amount: '₦100,000',
    description: 'Winner of the Royal Camel Area Science Club Schools Essay Competition in Igboland and International, demonstrating excellence in scientific writing and research.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/izoRqPZv7uCHZWbnJ1rXVJ/WhatsApp_Image_2025-10-24_at_13.20.17_%282%29.jpg'
  }, {
    title: 'National Mathematics Olympiad',
    category: 'Mathematics',
    year: '2023',
    amount: '₦150,000',
    description: 'First place in the National Mathematics Olympiad, showcasing exceptional problem-solving skills and mathematical reasoning.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg'
  }, {
    title: 'State Debate Championship',
    category: 'Debate',
    year: '2023',
    amount: '₦80,000',
    description: 'Champions of the Ogun State Inter-School Debate Competition, demonstrating excellent public speaking and argumentation skills.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg'
  }, {
    title: 'Regional Essay Writing Contest',
    category: 'Literature',
    year: '2023',
    amount: '₦120,000',
    description: 'Multiple winners in regional essay writing competitions across various topics, showcasing creative writing excellence.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xwrtKazFgq7H6urQHRmWav/WhatsApp_Image_2025-10-24_at_10.01.12_%281%29.jpg'
  }];
  const competitionCategories = [{
    name: 'Academic Competitions',
    achievements: ['National Mathematics Olympiad - 1st Place (2023)', 'Science Fair Regional Champions (2022, 2023)', 'Quiz Competition State Winners (2023)', 'Spelling Bee Regional Finalists (2023)']
  }, {
    name: 'Science & Technology',
    achievements: ['Royal Camel Science Club Winner (2024)', 'Robotics Challenge 2nd Place (2022)', 'Science Innovation Award (2023)', 'Environmental Science Project Award (2023)']
  }, {
    name: 'Arts & Literature',
    achievements: ['Essay Writing Competition Winners (2023)', 'Poetry Slam Regional Champions (2022)', 'Creative Writing Awards (2022, 2023)', 'Art Exhibition Best Display (2023)']
  }, {
    name: 'Debate & Public Speaking',
    achievements: ['State Debate Championship Winners (2023)', 'Model UN Best Delegate Awards (2022)', 'Public Speaking Competition Finalists (2023)', 'Oratory Contest Regional Winners (2022)']
  }, {
    name: 'Sports Achievements',
    achievements: ['Inter-School Athletics Meet - Multiple Medals (2023)', 'Football Tournament Regional Champions (2022)', 'Table Tennis Competition Winners (2023)', 'Track and Field State Qualifiers (2023)']
  }, {
    name: 'Character & Leadership',
    achievements: ['Best School Prefect Awards (Annual)', 'Community Service Recognition (2022, 2023)', 'Leadership Excellence Awards (2023)', 'Character Development Honors (Annual)']
  }];
  const galleryImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    alt: 'Trophy collection',
    caption: 'Our collection of academic and sports trophies'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/izoRqPZv7uCHZWbnJ1rXVJ/WhatsApp_Image_2025-10-24_at_13.20.17_%282%29.jpg',
    alt: 'Science competition trophy',
    caption: 'Royal Camel Area Science Club Competition trophy'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    alt: 'Students at assembly',
    caption: 'Award ceremony at morning assembly'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xwrtKazFgq7H6urQHRmWav/WhatsApp_Image_2025-10-24_at_10.01.12_%281%29.jpg',
    alt: 'School assembly hall',
    caption: 'Assembly hall where awards are presented'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    alt: 'Student with award',
    caption: 'Celebrating student achievements'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
    alt: 'Alumni gathering',
    caption: 'Alumni celebrating school achievements'
  }];
  return <div className="min-h-screen bg-white" data-id="element-5755">
      <PageHeader title="Prizes & Awards" description="Celebrating excellence and achievement at Isonyin Grammar School" backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Prizes & Awards',
      path: '/prizes-and-awards'
    }]} data-id="element-5756" />
      <div className="container mx-auto px-4 py-12" data-id="element-5757">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-5758">
          <div className="text-center mb-10" data-id="element-5759">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5760">
              Our Achievements
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5761"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5762">
              At Isonyin Grammar School, we celebrate excellence in academics,
              sports, and character development. Our students consistently excel
              in various competitions and receive recognition for their
              outstanding achievements.
            </p>
          </div>
          {/* Trophy Showcase */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-5763">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-5764">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" alt="Trophy awards" className="w-full h-96 object-cover" data-id="element-5765" />
              <div className="p-6" data-id="element-5766">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5767">
                  Academic Excellence Awards
                </h3>
                <p className="text-gray-700" data-id="element-5768">
                  Our students have won numerous trophies in academic
                  competitions, science fairs, and essay contests at local,
                  state, and national levels.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-5769">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/izoRqPZv7uCHZWbnJ1rXVJ/WhatsApp_Image_2025-10-24_at_13.20.17_%282%29.jpg" alt="Royal Camel Area Science Club trophy" className="w-full h-96 object-cover" data-id="element-5770" />
              <div className="p-6" data-id="element-5771">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5772">
                  Science Competition Winner
                </h3>
                <p className="text-gray-700" data-id="element-5773">
                  Winner of the Royal Camel Area Science Club Schools Essay
                  Competition in Igboland and International, demonstrating our
                  commitment to scientific excellence.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Recent Awards Section */}
        <section className="mb-16" data-id="element-5774">
          <div className="text-center mb-10" data-id="element-5775">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5776">
              Recent Awards & Recognitions
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5777"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5778">
              Our most recent achievements in various competitions and
              recognitions
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5779">
            {recentAwards.map((award, index) => <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-5780">
                <img src={award.image} alt={award.title} className="w-full h-64 object-cover" data-id="element-5781" />
                <div className="p-6" data-id="element-5782">
                  <div className="flex items-center justify-between mb-3" data-id="element-5783">
                    <span className="px-3 py-1 bg-blue-100 text-blue-900 rounded-full text-sm font-medium" data-id="element-5784">
                      {award.category}
                    </span>
                    <span className="text-gray-500 text-sm" data-id="element-5785">{award.year}</span>
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5786">
                    {award.title}
                  </h3>
                  {award.amount && <div className="text-2xl font-bold text-yellow-600 mb-3" data-id="element-5787">
                      {award.amount}
                    </div>}
                  <p className="text-gray-700" data-id="element-5788">{award.description}</p>
                </div>
              </div>)}
          </div>
        </section>
        {/* Competition Categories Section */}
        <section className="mb-16" data-id="element-5789">
          <div className="text-center mb-10" data-id="element-5790">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5791">
              Competition Categories
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5792"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5793">
              Our students excel across multiple disciplines and competition
              categories
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5794">
            {competitionCategories.map((category, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5795">
                <div className="flex items-center mb-4" data-id="element-5796">
                  <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5797">
                    <TrophyIcon className="h-6 w-6 text-blue-700" data-id="element-5798" />
                  </div>
                  <h3 className="text-xl font-bold text-blue-900" data-id="element-5799">
                    {category.name}
                  </h3>
                </div>
                <ul className="space-y-2" data-id="element-5800">
                  {category.achievements.map((achievement, idx) => <li key={idx} className="flex items-start" data-id="element-5801">
                      <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2 mt-0.5" data-id="element-5802">
                        <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-5803" />
                      </div>
                      <span className="text-gray-700 text-sm" data-id="element-5804">
                        {achievement}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </section>
        {/* Awards Gallery Section */}
        <section className="mb-16" data-id="element-5805">
          <div className="text-center mb-10" data-id="element-5806">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5807">
              Awards Gallery
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5808"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5809">
              A visual celebration of our students' achievements and the
              trophies they've won
            </p>
          </div>
          <Gallery images={galleryImages} columns={3} gap="medium" rounded={true} className="mb-8" data-id="element-5810" />
        </section>
        {/* Notable Achievements Section */}
        <section className="mb-16" data-id="element-5811">
          <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg p-8 md:p-12" data-id="element-5812">
            <div className="text-center mb-8" data-id="element-5813">
              <h2 className="text-3xl font-bold mb-3" data-id="element-5814">Notable Achievements</h2>
              <div className="w-24 h-1 bg-yellow-400 mx-auto" data-id="element-5815"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-5816">
              <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-5817">
                <div className="flex items-center mb-4" data-id="element-5818">
                  <div className="p-3 bg-yellow-400 rounded-full mr-3" data-id="element-5819">
                    <AwardIcon className="h-6 w-6 text-blue-900" data-id="element-5820" />
                  </div>
                  <h3 className="text-xl font-bold" data-id="element-5821">Academic Excellence</h3>
                </div>
                <ul className="space-y-2 text-blue-100" data-id="element-5822">
                  <li className="flex items-start" data-id="element-5823">
                    <span className="mr-2" data-id="element-5824">•</span>
                    <span data-id="element-5825">
                      95% distinction rate in WAEC examinations (2023)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-5826">
                    <span className="mr-2" data-id="element-5827">•</span>
                    <span data-id="element-5828">Multiple essay and debate competition victories</span>
                  </li>
                  <li className="flex items-start" data-id="element-5829">
                    <span className="mr-2" data-id="element-5830">•</span>
                    <span data-id="element-5831">
                      Consistent top performance in regional competitions
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-5832">
                <div className="flex items-center mb-4" data-id="element-5833">
                  <div className="p-3 bg-yellow-400 rounded-full mr-3" data-id="element-5834">
                    <TrophyIcon className="h-6 w-6 text-blue-900" data-id="element-5835" />
                  </div>
                  <h3 className="text-xl font-bold" data-id="element-5836">Competition Success</h3>
                </div>
                <ul className="space-y-2 text-blue-100" data-id="element-5837">
                  <li className="flex items-start" data-id="element-5838">
                    <span className="mr-2" data-id="element-5839">•</span>
                    <span data-id="element-5840">Over ₦550,000 in prize money won</span>
                  </li>
                  <li className="flex items-start" data-id="element-5841">
                    <span className="mr-2" data-id="element-5842">•</span>
                    <span data-id="element-5843">15+ awards across various categories</span>
                  </li>
                  <li className="flex items-start" data-id="element-5844">
                    <span className="mr-2" data-id="element-5845">•</span>
                    <span data-id="element-5846">
                      Recognition from prestigious organizations and foundations
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Call to Action */}
        <section data-id="element-5847">
          <div className="bg-blue-50 p-8 rounded-lg text-center" data-id="element-5848">
            <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5849">
              Be Part of Our Success Story
            </h2>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-5850">
              Join Isonyin Grammar School and discover your potential. Our
              supportive environment and excellent faculty help students achieve
              their dreams and win prestigious awards.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-5851">
              <a href="/admissions" className="px-6 py-3 bg-blue-900 text-white rounded-lg font-medium hover:bg-blue-800 transition-colors" data-id="element-5852">
                Apply for Admission
              </a>
              <a href="/contact" className="px-6 py-3 bg-white text-blue-900 border-2 border-blue-900 rounded-lg font-medium hover:bg-blue-50 transition-colors" data-id="element-5853">
                Learn More
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default PrizesAndAwards;